var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66659 5.83329H9.33325M4.66659 10.5H9.33325M4.66659 8.16663H6.99992M2.33325 12.4833V1.51663C2.33325 1.4238 2.37013 1.33478 2.43576 1.26914C2.5014 1.2035 2.59043 1.16663 2.68325 1.16663H9.48025C9.57305 1.16671 9.66201 1.20364 9.72759 1.26929L11.5639 3.10563C11.5966 3.13823 11.6224 3.17698 11.6401 3.21962C11.6577 3.26227 11.6667 3.30798 11.6666 3.35413V12.4833C11.6666 12.5293 11.6575 12.5748 11.6399 12.6172C11.6224 12.6597 11.5966 12.6983 11.5641 12.7308C11.5316 12.7633 11.493 12.7891 11.4505 12.8067C11.4081 12.8242 11.3625 12.8333 11.3166 12.8333H2.68325C2.63729 12.8333 2.59178 12.8242 2.54931 12.8067C2.50685 12.7891 2.46827 12.7633 2.43576 12.7308C2.40326 12.6983 2.37748 12.6597 2.35989 12.6172C2.34231 12.5748 2.33325 12.5293 2.33325 12.4833V12.4833Z",
    stroke: "#E8E8E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 1.16663V3.14996C9.33325 3.24279 9.37013 3.33181 9.43576 3.39745C9.5014 3.46308 9.59043 3.49996 9.68325 3.49996H11.6666",
    stroke: "#E8E8E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWin);
export default __webpack_public_path__ + "static/media/win.f254a0d4fa0e089020e1a4034007f36c.svg";
export { ForwardRef as ReactComponent };